var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsotypePlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 185,
    viewBox: "0 0 155 185",
    fill: "#2071F1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.055 70.6911V107.541C17.055 140.906 44.1172 167.954 77.5 167.954C110.883 167.954 137.945 140.906 137.945 107.541V70.6911V0H155V107.541C155 150.32 120.302 185 77.5 185C34.6979 185 0 150.32 0 107.541V0H17.055V70.6911Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6699 60.1626V106.287C52.6699 119.578 63.4498 130.352 76.7476 130.352C90.0453 130.352 100.825 119.578 100.825 106.287V60.1626V32.5881H117.88V106.287C117.88 128.992 99.4645 147.398 76.7476 147.398C54.0306 147.398 35.6149 128.992 35.6149 106.287V32.5881H52.6699V60.1626Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1577 0L77.2523 54.598L131.346 0.0030823L154.948 0L154.957 0.00927633L77.2586 78.7111L0.0509644 0H24.1577V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotypePlain);
export default __webpack_public_path__ + "static/media/isotype-plain.d6ba4ac0231f313b8313561f3b4f90f6.svg";
export { ForwardRef as ReactComponent };